export default __webpack_public_path__ + "media/images/gallery/35-ce60c83a7d88cd79ebc738f5a3c77fe4.png";